import { EventBasedStore } from '../../../utils/EventBasedStore';
import { scTrack } from '../../../utils/scTrack';
import { SidebarPanel } from './sidebars';

export const h5NavTrack = (name: string) => {
  scTrack('Web3H5NavigationBarClick', {
    button_name: name,
  });
};

export const panelStateStore = new EventBasedStore<{
  panel: SidebarPanel;
}>({
  panel: 'main',
});
